// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8xXRP","wrapper":"Header_wrapper__DJdEg","change_theme":"Header_change_theme__Z9evg","logo":"Header_logo__fsaDD","title":"Header_title__b53Ye"};